import { z } from 'zod'
import type { StorefrontOrder } from '@fa/pod-schema'

// Wire contract for S4 storefront order (Frontend ADR daniel-0015). Mirrors Hapi
// `CategoryOrder` / `DesignOrder` / assignment `orderSource` (daniel-0028, 0029).
export const designOrderingEntrySchema = z.object({ designId: z.number() })

const promotionDiscountSchema = z.object({
  photoProductId: z.number(),
  kind: z.enum(['PERCENT', 'FIXED_AMOUNT']),
  percent: z.number().nullable(),
  amountByCurrency: z.record(z.string(), z.number()).nullable(),
  percentByVariantId: z.record(z.string(), z.number()).optional(),
})

const promotionPresentationSchema = z.object({
  id: z.string(),
  phase: z.string().nullable(),
  isActive: z.boolean(),
  percentByCategory: z.record(z.string(), z.number()),
  maxPercent: z.number(),
  endsAt: z.string(),
  discounts: z.array(promotionDiscountSchema),
})

export const storefrontOrderSchema: z.ZodType<StorefrontOrder> = z.object({
  categoryOrder: z.array(z.string()),
  designOrder: z.record(z.string(), z.array(designOrderingEntrySchema)),
  everyUnit: promotionPresentationSchema.nullable().optional(),
  additionalUnit: promotionPresentationSchema.nullable().optional(),
  // Hapi ADR daniel-0046: every running Promotion per mechanic.
  everyUnits: z.array(promotionPresentationSchema).optional(),
  additionalUnits: z.array(promotionPresentationSchema).optional(),
  nextStartsAt: z.string().nullable().optional(),
})

export const orderSourceSchema = z.object({
  categoryOrder: z.enum(['override', 'inherited']),
  designOrder: z.enum(['override', 'inherited']),
})

// Present on a current Hapi assignment (daniel-0028). Optional on the TS type so
// an older Hapi without the fields still types as CampaignAssignment.
export const campaignAssignmentOrderSchema = storefrontOrderSchema.and(
  z.object({ orderSource: orderSourceSchema })
)
